import { Award } from '../objects/Award';
import { Division } from '../objects/Division';
import { Equipment } from '../objects/Equipment';
import { MandatePeriod } from '../objects/MandatePeriod';
import { MissionType } from '../objects/MissionType';
import { Setting } from '../objects/Setting';
import { OrganizationType } from '../objects/OrganizationType';
import { Party } from '../objects/Party';
import { WageCalculation } from '../objects/WageCalculation';
import { WageType } from '../objects/WageType';

import { ResourceEndpoint } from './ResourceEndpoint';
import { MeetingEndpoint } from './MeetingEndpoint';
import { MissionEndpoint } from './MissionEndpoint';
import { SystemEndpoint } from './SystemEndpoint';
import { OrganizationEndpoint } from './OrganizationEndpoint';
import { PersonEndpoint } from './PersonEndpoint';
import { WageGroupEndpoint } from './WageGroupEndpoint';
import { PaymentRoundEndpoint } from './PaymentRoundEndpoint';
import { ReportEndpoint } from './ReportEndpoint';
import { MissionGroupEndpoint } from './MissionGroupEndpoint';
import { PayrollEndpoint } from './PayrollEndpoint';
import { IntegrationEndpoint } from './IntegrationEndpoint';
import { NotificationEndpoint } from './NotificationEndpoint';
import { CeremonyEndpoint } from './CeremonyEndpoint';

import { ApiService } from './ApiService';
import { PolitikerEndpoint } from './PolitikerEndpoint';
import { FileEndpoint } from './FileEndpoint';

/**
 * @typedef { import('../../auth/Authentication').Authentication } Authentication
 */

export class ApiServer {

    /**
     *
     * @param {Authentication} auth
     * @param {string} apiurl
     */
    constructor(auth, apiurl) {
        let api = new ApiService(auth, apiurl);

        this.Awards = new ResourceEndpoint('/api/awards', api, Award);
        this.Divisions = new ResourceEndpoint('/api/divisions', api, Division);
        this.Equipment = new ResourceEndpoint('/api/equipment', api, Equipment);
        this.MandatePeriods = new ResourceEndpoint('/api/mandates', api, MandatePeriod);
        this.MissionTypes = new ResourceEndpoint('/api/missiontypes', api, MissionType);
        this.Settings = new ResourceEndpoint('/api/settings', api, Setting);
        this.OrganizationTypes = new ResourceEndpoint('/api/organizationtypes', api, OrganizationType);
        this.Parties = new ResourceEndpoint('/api/parties', api, Party);
        this.WageCalculations = new ResourceEndpoint('/api/wagecalculations', api, WageCalculation);
        this.WageTypes = new ResourceEndpoint('/api/wagetypes', api, WageType);

        this.Meetings = new MeetingEndpoint('/api/meetings', api);
        this.Missions = new MissionEndpoint('/api/missions', api);
        this.System = new SystemEndpoint('/api/system', api);
        this.Organizations = new OrganizationEndpoint('/api/organizations', api);
        this.Persons = new PersonEndpoint('/api/persons', api);
        this.WageGroups = new WageGroupEndpoint('/api/wagegroups', api);
        this.PaymentRounds = new PaymentRoundEndpoint('/api/rounds', api);
        this.MissionGroups = new MissionGroupEndpoint('/api/missiongroups', api);
        this.Payroll = new PayrollEndpoint('/api/payroll', api);

        this.Reports = new ReportEndpoint('/api/reports', api);
        this.Notifications = new NotificationEndpoint('/api/notifications', api);

        this.Integrations = new IntegrationEndpoint('/api/integrations', api);

        this.Ceremonies = new CeremonyEndpoint('/api/ceremonies', api);
        this.Politiker = new PolitikerEndpoint('/api/politiker', api);
        this.Files = new FileEndpoint('/api/files', api);
    }
}